import { render } from "./trajectory.vue?vue&type=template&id=1ae5c28d&scoped=true"
import script from "./trajectory.vue?vue&type=script&lang=js"
export * from "./trajectory.vue?vue&type=script&lang=js"

import "./trajectory.vue?vue&type=style&index=0&id=1ae5c28d&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae5c28d"]])

export default __exports__